// Single source of truth for the API base URL, shared by every openapi-fetch
// client (admin, auth, public intake). In production VITE_API_BASE_URL points
// at the separate API domain (e.g. https://dev.api.rentreadypet.com); locally
// it is unset and we fall back to same-origin so the Vite dev proxy handles /api.

export function resolveApiBaseUrl(envBase: string | undefined, pageOrigin: string): string {
  return new URL('/api/v1', envBase ?? pageOrigin).toString()
}

export function apiBaseUrl(): string {
  return resolveApiBaseUrl(
    import.meta.env.VITE_API_BASE_URL as string | undefined,
    window.location.origin,
  )
}
